/** @format */

import React from "react";
import { Switch, Route } from "react-router-dom";
import { BrowserRouter as Router } from "react-router-dom";
import AuthContextProvider from "./Contexts/AuthContext";
import Content from "./Components/Common/Content";
import Blank from "./Components/Common/Blank";
import Users from "./Components/User/Index";
import Tenants from "./Components/Tenant/Index";
import Dashboard from "./Components/Dashboard/Dashboard";
import UserDashboard from "./Components/UserDashboard/Dashboard";
import Login from "./Components/Login/Login";
import Form from "./Components/Onboarding/Form";
import MigrationList from "./Components/Migration/Index";
import PrivateRoute from "./Config/PrivateRoute";
import AddUser from "./Components/User/AddUser";
import UserDetail from "./Components/User/UserDetail";
import UpdateUser from "./Components/User/UpdateUser";
import POS from "./Components/POS/Index";
import PosDetail from "./Components/POS/PosDetail";
import EditPOS from "./Components/POS/EditPOS";
import AddPos from "./Components/POS/AddPos";
import TenantDetail from "./Components/Tenant/TenantDetail";
import TenantUpdate from "./Components/Tenant/TenantUpdate";
import Error from "./Components/Common/Error";
import Stores from "./Components/Store/Index";
import InvoicesIssuedReport from "./Components/Report/InvoicesIssuedReport/Index";
import InvoicesCashBalanceReport from "./Components/Report/InvoiceCashBalance/Index";
import InvoicesConclusionCashBalance from "./Components/Report/InvoicesConclusionCashBalance/Index";
import InvoicesList from "./Components/Report/InvoicesList/Index";
import InvoicesTotal from "./Components/Report/InvoicesTotal/Index";
import InvoicesPaymentMethod from "./Components/Report/InvoicesPaymentMethod/Index";
import InvoicesUnfiscalizedAccounts from "./Components/Report/InvoicesUnfiscalizedAccounts/Index";
import TipsIssuedReport from "./Components/Report/TipsIssuedReport/Index";
import StoreAdd from "./Components/Store/StoreAdd";
import StoreDetail from "./Components/Store/StoreDetail";
import StoreUpdate from "./Components/Store/StoreUpdate";
import Partners from "./Components/Partners/Index";
import PriceList from "./Components/PriceList";
import EditPriceList from "./Components/PriceList/EditPriceList";
import EditItemGroup from "./Components/ItemGroup/EditItemGroup";
import EditItem from "./Components/Item/EditItem";
import EditRawMaterial from "./Components/Item/EditRawMaterial";
import Language from "./Components/Language";
import EditLanguage from "./Components/Language/EditLanguage";
import AddLanguage from "./Components/Language/AddLanguage";
import ForgotPassword from "./Components/Login/ForgotPassword";
import UpdatePartner from "./Components/Partners/UpdatePartner";
import TaxRates from "./Components/TaxRates/Index";
import TaxRatesAdd from "./Components/TaxRates/TaxRateAdd";
import AddPartner from "./Components/Partners/AddPartner";
import CertificateUpdate from "./Components/Certificate/CertificateUpdate";
import CertificateUpload from "./Components/Certificate/CertificateUpload";
import CertificateMiniUpload from "./Components/Certificate/CertificateUploadMini";
import CertificateDetails from "./Components/Certificate/CertificateDetail";
import PayOption from "./Components/PayOption/Index";
import UnitOfMeasure from "./Components/UnitOfMeasure";
import EditUnitOfMeasure from "./Components/UnitOfMeasure/EditUnitOfMeasure";
import AddPayOption from "./Components/PayOption/AddPayOption";
import UpdatePayOption from "./Components/PayOption/UpdatePayOption";
import Messages from "./Components/Message/Index";
import AddMessage from "./Components/Message/AddMessage";
import BulkImport from "./Components/Item/BulkImport";
import ShiftAdd from "./Components/Shifts/ShiftAdd";
import ShiftUpdate from "./Components/Shifts/ShiftUpdate";
import PublicRoute from "./Config/PublicRoute";
import RecoverPassword from "./Components/Login/RecoverPassword";
import SwitchTenant from "./Components/Tenant/SwitchTenant";
import ErrorPage from "./Components/Common/ErrorPage";
import NotFound from "./Components/Common/NotFound";
import Logs from "./Components/Logs/Index";
import InitialState from "./Components/Accounting/InitialState/Index";
import InitialStateDocumetCreate from "./Components/Accounting/InitialState/DocumentCreate";
import InitialStateDocumetDetails from "./Components/Accounting/InitialState/DocumentDetails";
import PriceChangeIndex from "./Components/Accounting/PriceChange/Index";
import PriceChangeCreate from "./Components/Accounting/PriceChange/DocumentCreate";
import PriceChangeDetails from "./Components/Accounting/PriceChange/DocumentDetails";
import CalculationIndex from "./Components/Accounting/Calculation/Index";
import CalculationCreate from "./Components/Accounting/Calculation/DocumentCreate";
import CalculationDetails from "./Components/Accounting/Calculation/DocumentDetails";
import Predisposition from "./Components/Accounting/Predisposition/Index";
import PredispositionCreate from "./Components/Accounting/Predisposition/DocumentCreate";
import PredispositionDetails from "./Components/Accounting/Predisposition/DocumentDetails";
import ReturnReceiptIndex from "./Components/Accounting/ReturnReceipt/Index";
import ReturnReceiptCreate from "./Components/Accounting/ReturnReceipt/DocumentCreate";
import ReturnReceiptDetails from "./Components/Accounting/ReturnReceipt/DocumentDetails";
import InternalOutput from "./Components/Accounting/InternalOutput/Index";
import InternalOutputCreate from "./Components/Accounting/InternalOutput/DocumentCreate";
import InternalOutputDetails from "./Components/Accounting/InternalOutput/DocumentDetails";
import StateOfRetail from "./Components/Accounting/StateOfRetail/Index";
import StoreStock from "./Components/Accounting/StoreStock/Index";
import InventoryIndex from "./Components/Accounting/Inventory/Index";
import InventoryCreate from "./Components/Accounting/Inventory/DocumentCreate";
import InventoryDetails from "./Components/Accounting/Inventory/DocumentDetails";
import CardTypes from "./Components/CardTypes/Index";
import Traffic from "./Components/Accounting/Traffic/Index";
import Recapitulation from "./Components/Accounting/Recapitulation/Index";
import BulkImportPartner from "./Components/Partners/BulkImport";
import ItemDetails from "./Components/Item/ItemDetails";
import HandoverIndex from "./Components/Accounting/Handover/Index";
import HandoverCreate from "./Components/Accounting/Handover/DocumentCreate/IndexCreate";
import HandoverDetails from "./Components/Accounting/Handover/DocumentDetails/IndexDetails";
import ConsumptionIndex from "./Components/Accounting/Consumption/Index";
import ConsumptionCreate from "./Components/Accounting/Consumption/DocumentCreate/IndexCreate";
import ConsumptionDetails from "./Components/Accounting/Consumption/DocumentDetails/IndexDetails";
import Instructions from "./Components/Instructions/Index";
import VideoInstructions from "./Components/VideoInstructions/Index";
import PublicOnboadringPage from "./Components/PublicOnboarding/Page";
import NoLayoutContent from "./Components/Common/NoLayoutContent";
import PublicOnboadringInitialPage from "./Components/PublicOnboardingInitial/Page";
import PublicOnboardingExistingPage from "./Components/PublicOnboardingExisting/Page";
import KnowledgeBase from "./Components/KnowledgeBase/KnowledgeBase";

import PosVersion from "./Components/PosVersion/Index";
import ManagingVersions from "./Components/PosVersion/ManagingVersions";
import Reporting from "./Components/PosVersion/Reporting";
import Survey from "./Components/Survey/Index";
import Support from "./Components/Support/Index";
import SupportStatistics from "./Components/Support/Statistics";
import DigitalContent from "./Components/DigitalContent/Index";

const App = () => {
  // window.REACT_APP_HASH_KEY = "Combis123";
  // window.REACT_APP_ENV = "Test";
  // window.REACT_APP_COLOR = "#e20074";
  // window.REACT_APP_ALERT_COLOR = "#dc3545ee";
  // window.REACT_APP_LOGIN_IMAGE = "posBackground.jpg";
  // window.REACT_APP_VENDOR = "ht";
  // window.REACT_APP_AICHAT = true;

  return (
    <>
      <div className="App">
        <Router>
          <AuthContextProvider>
            <Switch>
              <PublicRoute
                path="/recovery"
                component={RecoverPassword}
                layout={Content}
                publicRoute={true}
              />
              <PublicRoute
                path="/login"
                component={Login}
                layout={Content}
                publicRoute={true}
              />
              <PublicRoute
                path="/forgot-password"
                component={ForgotPassword}
                layout={Content}
                publicRoute={true}
              />

              <PublicRoute
                path="/public/onboarding-initial"
                component={PublicOnboadringInitialPage}
                layout={NoLayoutContent}
                publicRoute={true}
              />

              <PublicRoute
                path="/public/onboarding"
                component={PublicOnboadringPage}
                layout={NoLayoutContent}
                publicRoute={true}
              />

              <PublicRoute
                path="/public/onboarding-existing"
                component={PublicOnboardingExistingPage}
                layout={NoLayoutContent}
                publicRoute={true}
              />

              <PrivateRoute
                exact
                path="/"
                component={Dashboard}
                layout={Content}
              />
              <PrivateRoute
                exact
                path="/dashboard"
                component={UserDashboard}
                layout={Content}
              />
              <PrivateRoute
                exact
                path="/logs"
                component={Logs}
                layout={Content}
              />
              <PrivateRoute
                path="/users"
                exact
                component={Users}
                layout={Content}
                parentRoute="/users"
                parentName="Breadcrumb-Users"
              />
              <PrivateRoute
                path="/adduser"
                component={AddUser}
                layout={Content}
                parentRoute="/users"
                parentName="Breadcrumb-Users"
                currentName="Breadcrumb-NewUser"
                show={true}
              />
              <PrivateRoute
                path="/users/:userId"
                component={UserDetail}
                layout={Content}
                parentRoute="/users"
                parentName="Breadcrumb-Users"
                currentName="Breadcrumb-UserDetail"
              />
              <PrivateRoute
                path="/update-user/:userId"
                component={UpdateUser}
                layout={Content}
                parentRoute="/users"
                parentName="Breadcrumb-Users"
                currentName="Breadcrumb-EditUser"
                show={true}
              />
              <PrivateRoute
                path="/tenants"
                exact
                component={Tenants}
                layout={Content}
                parentRoute="/tenants"
                parentName="Breadcrumb-Tenants"
              />
              <PrivateRoute
                path="/tenants/:tenantId"
                component={TenantDetail}
                layout={Content}
                parentRoute="/tenants"
                parentName="Breadcrumb-Tenants"
                currentName="Breadcrumb-TenantDetail"
              />
              <PrivateRoute
                path="/update-tenant/:tenantId"
                component={TenantUpdate}
                layout={Content}
                parentRoute="/tenants"
                parentName="Breadcrumb-Tenants"
                currentName="Breadcrumb-EditTenant"
                show={true}
              />
              <PrivateRoute
                path="/stores"
                exact
                component={Stores}
                layout={Content}
                parentRoute="/stores"
                parentName="Breadcrumb-Stores"
              />
              <PrivateRoute
                path="/store-add"
                component={StoreAdd}
                layout={Content}
                parentRoute="/stores"
                parentName="Breadcrumb-Stores"
                currentName="Breadcrumb-NewStore"
                show={true}
              />
              <PrivateRoute
                path="/stores/:storeId"
                component={StoreDetail}
                layout={Content}
                parentRoute="/stores"
                parentName="Breadcrumb-Stores"
                currentName="Breadcrumb-StoreDetail"
              />
              <PrivateRoute
                path="/update-store/:storeId"
                component={StoreUpdate}
                layout={Content}
                parentRoute="/stores"
                parentName="Breadcrumb-Stores"
                currentName="Breadcrumb-EditingStore"
                show={true}
              />

              <PrivateRoute
                path="/invoices-issued-report"
                exact
                component={InvoicesIssuedReport}
                layout={Content}
                parentName="Breadcrumb-Reports"
                currentName="Breadcrumb-InvoicesIssuedReport"
              />
              <PrivateRoute
                path="/invoices-conclusion-report"
                exact
                component={InvoicesConclusionCashBalance}
                layout={Content}
                parentName="Breadcrumb-Reports"
                currentName="Breadcrumb-InvoicesConclusionReport"
              />

              <PrivateRoute
                path="/invoices-cash-balance"
                exact
                component={InvoicesCashBalanceReport}
                layout={Content}
                parentRoute="/reports"
                parentName="Breadcrumb-Reports"
                currentName="Breadcrumb-CashBalance"
              />

              <PrivateRoute
                path="/invoices-invoiceslist"
                exact
                component={InvoicesList}
                layout={Content}
                parentRoute="/reports"
                parentName="Breadcrumb-Reports"
                currentName="Breadcrumb-InvoicesList"
              />

              <PrivateRoute
                path="/invoices-invoicesTotal"
                exact
                component={InvoicesTotal}
                layout={Content}
                parentRoute="/reports"
                parentName="Breadcrumb-Reports"
                currentName="Breadcrumb-InvoicesTotal"
              />

              <PrivateRoute
                path="/invoices-invoicesPaymentMethod"
                exact
                component={InvoicesPaymentMethod}
                layout={Content}
                parentRoute="/reports"
                parentName="Breadcrumb-Reports"
                currentName="Breadcrumb-InvoicesPaymentMethod"
              />

              <PrivateRoute
                path="/invoices-invoicesUnfiscalizedAccounts"
                exact
                component={InvoicesUnfiscalizedAccounts}
                layout={Content}
                parentRoute="/reports"
                parentName="Breadcrumb-Reports"
                currentName="Breadcrumb-InvoicesUnfiscalizedAccounts"
              />
              <PrivateRoute
                path="/tips-issued-report"
                exact
                component={TipsIssuedReport}
                layout={Content}
                parentRoute="/reports"
                parentName="Breadcrumb-Reports"
                currentName="Breadcrumb-TipsIssuedReport"
              />

              <PrivateRoute
                path="/onboarding"
                component={Form}
                layout={Content}
                parentRoute="/onboarding"
                parentName="Breadcrumb-OnboardingProcess"
              />
              <PrivateRoute
                path="/pos"
                exact
                component={POS}
                layout={Content}
                parentRoute="/pos"
                parentName="Breadcrumb-POSDevices"
              />
              <PrivateRoute
                path="/pos/:posId"
                exact
                component={PosDetail}
                layout={Content}
                parentRoute="/pos"
                parentName="Breadcrumb-POSDevices"
                currentName="Breadcrumb-POSDevicesDetails"
              />
              <PrivateRoute
                path="/add-pos"
                exact
                component={AddPos}
                layout={Content}
                parentRoute="/pos"
                parentName="Breadcrumb-POSDevices"
                currentName="Breadcrumb-NewPOSDevice"
              />
              <PrivateRoute
                path="/edit-pos/:posId"
                exact
                component={EditPOS}
                layout={Content}
                parentRoute="/pos"
                parentName="Breadcrumb-POSDevices"
                currentName="Breadcrumb-POSDeviceEdit"
              />
              <PrivateRoute
                path="/price-list"
                exact
                component={PriceList}
                layout={Content}
                parentRoute="/price-list"
                parentName="Breadcrumb-PriceList"
              />
              <PrivateRoute
                path="/add-price-list"
                exact
                component={EditPriceList}
                layout={Content}
                parentRoute="/price-list"
                parentName="Breadcrumb-PriceList"
                currentName="Breadcrumb-NewPriceList"
              />
              <PrivateRoute
                path="/edit-price-list/:priceListId"
                exact
                component={EditPriceList}
                layout={Content}
                parentRoute="/price-list"
                parentName="Breadcrumb-PriceList"
                currentName="Breadcrumb-PriceListEdit"
              />
              <PrivateRoute
                path="/add-item-group/:tenantId"
                exact
                component={EditItemGroup}
                layout={Content}
                parentRoute="/item-group"
                parentName="Breadcrumb-ItemGroup"
                currentName="Breadcrumb-NewItemGroup"
                show={true}
              />
              <PrivateRoute
                path="/edit-item-group/:tenantId/:itemGroupId"
                exact
                component={EditItemGroup}
                layout={Content}
                parentRoute="/item-group"
                parentName="Breadcrumb-ItemGroup"
                currentName="Breadcrumb-EditItemGroup"
                show={true}
              />
              <PrivateRoute
                path="/add-item/:priceListId"
                exact
                component={EditItem}
                layout={Content}
                parentRoute="/item"
                parentName="Breadcrumb-Item"
                currentName="Breadcrumb-NewItem"
                show={true}
              />
              <PrivateRoute
                path="/add-raw-material/:priceListId"
                exact
                component={EditRawMaterial}
                layout={Content}
                parentRoute="/item"
                parentName="Breadcrumb-Item"
                currentName="Breadcrumb-NewItem"
                show={true}
              />
              <PrivateRoute
                path="/item-details/:priceListId/:itemId"
                exact
                component={ItemDetails}
                layout={Content}
                parentRoute="/item"
                parentName="Breadcrumb-Item"
                currentName="Breadcrumb-ItemDetails"
                show={true}
              />
              <PrivateRoute
                path="/edit-item/:priceListId/:itemId"
                exact
                component={EditItem}
                layout={Content}
                parentRoute="/item"
                parentName="Breadcrumb-Item"
                currentName="Breadcrumb-EditItem"
                show={true}
              />
              <PrivateRoute
                path="/edit-raw-material/:priceListId/:itemId"
                exact
                component={EditRawMaterial}
                layout={Content}
                parentRoute="/item"
                parentName="Breadcrumb-Item"
                currentName="Breadcrumb-EditItem"
                show={true}
              />
              <PrivateRoute
                path="/item-bulk-import/:priceListId"
                exact
                component={BulkImport}
                layout={Content}
                parentRoute="/item"
                parentName="Breadcrumb-Items"
                show={true}
              />
              <PrivateRoute
                path="/partner-bulk-import/:tenantId"
                exact
                component={BulkImportPartner}
                layout={Content}
                parentRoute="/item"
                parentName="Breadcrumb-Items"
                show={true}
              />

              <PrivateRoute
                path="/language"
                exact
                component={Language}
                layout={Content}
                parentRoute="/language"
                parentName="Breadcrumb-Language"
                currentName="Breadcrumb-Language"
              />
              <PrivateRoute
                path="/add-language"
                exact
                component={AddLanguage}
                layout={Content}
                parentRoute="/language"
                parentName="Breadcrumb-Language"
                currentName="Breadcrumb-NewLanguage"
                show={true}
              />
              <PrivateRoute
                path="/edit-language/:languageId"
                exact
                component={EditLanguage}
                layout={Content}
                parentRoute="/language"
                parentName="Breadcrumb-Language"
                currentName="Breadcrumb-EditLanguage"
                show={true}
              />

              <PrivateRoute
                exact
                path="/knowledge-base"
                component={KnowledgeBase}
                layout={Content}
              />
              <PrivateRoute
                path="/unit-of-measures"
                exact
                component={UnitOfMeasure}
                layout={Content}
                parentRoute="/unit-of-measures"
                parentName="Breadcrumb-UnitOfMeasures"
                currentName="Breadcrumb-UnitOfMeasures"
              />
              <PrivateRoute
                path="/edit-unit-of-measure/:unitOfMeasureId"
                exact
                component={EditUnitOfMeasure}
                layout={Content}
                parentRoute="/unit-of-measures"
                parentName="Breadcrumb-UnitOfMeasures"
                currentName="Breadcrumb-EditUnitOfMeasures"
                show={true}
              />
              <PrivateRoute
                path="/add-unit-of-measure"
                exact
                component={EditUnitOfMeasure}
                layout={Content}
                parentRoute="/unit-of-measures"
                parentName="Breadcrumb-UnitOfMeasures"
                currentName="Breadcrumb-NewUnitOfMeasures"
                show={true}
              />

              {/* <PrivateRoute
                path="/add-language"
                exact
                component={EditLanguage}
                layout={Content}
                parentRoute="/language"
                parentName="Jezik"
              />
              <PrivateRoute
                path="/edit-language/:languageId"
                exact
                component={EditLanguage}
                layout={Content}
                parentRoute="/language"
                parentName="Jezik"
              /> */}
              <PrivateRoute
                path="/partners"
                exact
                component={Partners}
                layout={Content}
                parentRoute="/partners"
                parentName="Breadcrumb-Partners"
                show={true}
              />
              <PrivateRoute
                path="/update-partner/:partnerId"
                component={UpdatePartner}
                layout={Content}
                parentRoute="/partners"
                parentName="Breadcrumb-Partners"
                currentName="Breadcrumb-EditPartners"
                show={true}
              />
              <PrivateRoute
                path="/addpartner"
                component={AddPartner}
                layout={Content}
                parentRoute="/partners"
                parentName="Breadcrumb-Partners"
                currentName="Breadcrumb-NewPartner"
              />
              <PrivateRoute
                path="/tax-rates"
                component={TaxRates}
                layout={Content}
                parentRoute="/tax-rates"
                parentName="Breadcrumb-TaxRates"
              />
              <PrivateRoute
                path="/tax-rate-add"
                component={TaxRatesAdd}
                layout={Content}
                parentRoute="/tax-rates-add"
                parentName="Breadcrumb-TaxRates"
                currentName="Breadcrumb-NewTaxRate"
                show={true}
              />
              <PrivateRoute
                path="/certificates/:certificateId"
                component={CertificateDetails}
                layout={Content}
                parentRoute="/tenants"
                parentName="Breadcrumb-Certificates"
                currentName="Breadcrumb-CertificateDetails"
                show={true}
              />
              <PrivateRoute
                path="/upload-certificate"
                component={CertificateUpload}
                layout={Content}
                parentRoute="/tenants"
                parentName="Breadcrumb-Certificates"
                currentName="Breadcrumb-CertificateDetails"
                show={true}
              />
              <PrivateRoute
                path="/upload-mini-certificate"
                component={CertificateMiniUpload}
                layout={Content}
                parentRoute="/tenants"
                parentName="Breadcrumb-Certificates"
                currentName="Breadcrumb-CertificateDetails"
                show={true}
              />
              <PrivateRoute
                path="/update-certificate/:certificateId"
                component={CertificateUpdate}
                layout={Content}
                parentRoute="/tenants"
                parentName="Breadcrumb-Certificates"
                currentName="Breadcrumb-CertificateEdit"
              />
              <PrivateRoute
                path="/pay-methods"
                exact
                component={PayOption}
                layout={Content}
                parentRoute="/pay-methods"
                parentName="Breadcrumb-PayMethods"
              />
              <PrivateRoute
                path="/add-pay-methods"
                exact
                component={AddPayOption}
                layout={Content}
                parentRoute="/pay-methods"
                parentName="Breadcrumb-PayMethods"
                currentName="Breadcrumb-NewPayMethod"
                show={true}
              />
              <PrivateRoute
                path="/update-pay-methods/:payOptionId"
                component={UpdatePayOption}
                layout={Content}
                parentRoute="/pay-methods"
                parentName="Breadcrumb-PayMethods"
                currentName="Breadcrumb-EditPayMethod"
                show={true}
              />

              <PrivateRoute
                path="/card-types"
                exact
                component={CardTypes}
                layout={Content}
                partentRoute="/card-types"
                partentName="Breadcrumb-CardTypes"
              />
              <PrivateRoute
                path="/pos-versions"
                exact
                component={PosVersion}
                layout={Content}
                partentRoute="/pos-versions"
                partentName="Breadcrumb-PosVersions"
              />
              <PrivateRoute
                path="/version-managing"
                exact
                component={ManagingVersions}
                layout={Content}
                partentRoute="/version-managing"
                partentName="Breadcrumb-PosVersions"
              />
              <PrivateRoute
                path="/version-reporting"
                exact
                component={Reporting}
                layout={Content}
                partentRoute="/version-reporting"
                partentName="Breadcrumb-PosVersions"
              />

              <PrivateRoute
                path="/digital-content"
                exact
                component={DigitalContent}
                layout={Content}
                partentRoute="/digital-content"
                partentName="Breadcrumb-DigitalContent"
              />
              <PrivateRoute
                path="/surveys"
                exact
                component={Survey}
                layout={Content}
                partentRoute="/surveys"
                partentName="Breadcrumb-Surveys"
              />
              <PrivateRoute
                path="/support"
                exact
                component={Support}
                layout={Content}
                partentRoute="/support"
                partentName="Breadcrumb-Support"
              />
              <PrivateRoute
                path="/support-statistics"
                exact
                component={SupportStatistics}
                layout={Content}
                partentRoute="/support-statistics"
                partentName="Breadcrumb-Support"
              />
              <PrivateRoute
                path="/messages"
                exact
                component={Messages}
                layout={Content}
                parentRoute="/messages"
                parentName="Breadcrumb-Messages"
              />

              <PrivateRoute
                path="/addmessage"
                component={AddMessage}
                layout={Content}
                parentRoute="/messages"
                parentName="Breadcrumb-Messages"
                currentName="Breadcrumb-NewMessage"
                show={true}
              />

              <PrivateRoute
                path="/shift-add/:storeId"
                component={ShiftAdd}
                layout={Content}
                parentRoute="/shifts"
                parentName="Breadcrumb-Shifts"
                currentName="Breadcrumb-NewShift"
                show={true}
              />

              <PrivateRoute
                path="/shift-update/:shiftId/:storeId"
                component={ShiftUpdate}
                layout={Content}
                parentRoute="/shifts"
                parentName="Breadcrumb-Shifts"
                currentName="Breadcrumb-EditShift"
                show={true}
              />

              <PrivateRoute
                exact
                path="/switch-tenant"
                component={SwitchTenant}
                layout={Blank}
              />
              <PrivateRoute
                exact
                path="/initial-state"
                component={InitialState}
                layout={Content}
              />
              <PrivateRoute
                exact
                path="/initial-state-create"
                component={InitialStateDocumetCreate}
                layout={Content}
              />
              <PrivateRoute
                exact
                path="/initial-state-details/:documentId"
                component={InitialStateDocumetDetails}
                layout={Content}
              />
              <PrivateRoute
                exact
                path="/price-change"
                component={PriceChangeIndex}
                layout={Content}
              />
              <PrivateRoute
                exact
                path="/price-change-create"
                component={PriceChangeCreate}
                layout={Content}
              />
              <PrivateRoute
                exact
                path="/price-change-details/:documentId"
                component={PriceChangeDetails}
                layout={Content}
              />
              <PrivateRoute
                exact
                path="/calculation"
                component={CalculationIndex}
                layout={Content}
              />
              <PrivateRoute
                exact
                path="/calculation-create"
                component={CalculationCreate}
                layout={Content}
              />
              <PrivateRoute
                exact
                path="/calculation-details/:documentId"
                component={CalculationDetails}
                layout={Content}
              />
              <PrivateRoute
                exact
                path="/returnReceipt"
                component={ReturnReceiptIndex}
                layout={Content}
              />
              <PrivateRoute
                exact
                path="/returnReceipt-create"
                component={ReturnReceiptCreate}
                layout={Content}
              />
              <PrivateRoute
                exact
                path="/returnReceipt-details/:documentId"
                component={ReturnReceiptDetails}
                layout={Content}
              />
              <PrivateRoute
                exact
                path="/predisposition"
                component={Predisposition}
                layout={Content}
              />
              <PrivateRoute
                exact
                path="/predisposition-create"
                component={PredispositionCreate}
                layout={Content}
              />
              <PrivateRoute
                exact
                path="/predisposition-details/:documentId"
                component={PredispositionDetails}
                layout={Content}
              />
              <PrivateRoute
                exact
                path="/internal-output"
                component={InternalOutput}
                layout={Content}
              />
              <PrivateRoute
                exact
                path="/internal-output-create"
                component={InternalOutputCreate}
                layout={Content}
              />
              <PrivateRoute
                exact
                path="/internal-output-details/:documentId"
                component={InternalOutputDetails}
                layout={Content}
              />
              <PrivateRoute
                exact
                path="/retail-state"
                component={StateOfRetail}
                layout={Content}
              />
              <PrivateRoute
                exact
                path="/store-stock"
                component={StoreStock}
                layout={Content}
              />
              <PrivateRoute
                exact
                path="/traffic"
                component={Traffic}
                layout={Content}
              />
              <PrivateRoute
                exact
                path="/recapitulation"
                component={Recapitulation}
                layout={Content}
              />

              <PrivateRoute
                exact
                path="/inventory"
                component={InventoryIndex}
                layout={Content}
              />
              <PrivateRoute
                exact
                path="/inventory-create"
                component={InventoryCreate}
                layout={Content}
              />
              <PrivateRoute
                exact
                path="/inventory-details/:documentId"
                component={InventoryDetails}
                layout={Content}
              />
              <PrivateRoute
                exact
                path="/handover"
                component={HandoverIndex}
                layout={Content}
              />
              <PrivateRoute
                exact
                path="/handover-create"
                component={HandoverCreate}
                layout={Content}
              />
              <PrivateRoute
                exact
                path="/handover-details/:documentId"
                component={HandoverDetails}
                layout={Content}
              />
              <PrivateRoute
                exact
                path="/consumption"
                component={ConsumptionIndex}
                layout={Content}
              />
              <PrivateRoute
                exact
                path="/consumption-create"
                component={ConsumptionCreate}
                layout={Content}
              />
              <PrivateRoute
                exact
                path="/consumption-details/:documentId"
                component={ConsumptionDetails}
                layout={Content}
              />
              <PrivateRoute
                exact
                path="/migration"
                component={MigrationList}
                layout={Content}
              />
              <PrivateRoute
                exact
                path="/instructions"
                component={Instructions}
                layout={Content}
              />
              <PrivateRoute
                exact
                path="/video-instructions"
                component={VideoInstructions}
                layout={Content}
              />
              <PublicRoute
                exact
                path="/error-page/:code"
                component={ErrorPage}
                layout={Blank}
              />
              <Route path="/error" exact>
                <Error />
              </Route>
              <PrivateRoute component={NotFound} layout={Blank} />
            </Switch>
          </AuthContextProvider>
        </Router>
      </div>
    </>
  );
};

export default App;
